import { get } from '../../api';

export const getRequisicoes = (idConfiguracao, page) => {
  return get(`/api/conectores/requisicoes/${idConfiguracao}?page=${page}`);
};
